var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTopVolume(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.668 33H30.668V39H34.668V33Z",
    fill: "#CDD2E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.668 9V21H8.66797H7.66797V9H8.66797H11.668Z",
    fill: "#D2C7FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.668 24H18.298C18.6368 25.0503 19.1108 26.052 19.708 26.98L19.668 27H14.668C13.0767 27 11.5505 26.3679 10.4253 25.2426C9.30011 24.1174 8.66797 22.5913 8.66797 21H11.668C11.668 21.7956 11.984 22.5587 12.5466 23.1213C13.1093 23.6839 13.8723 24 14.668 24Z",
    fill: "#AE9AFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.668 6V9H8.66797V3H17.668V6H11.668Z",
    fill: "#AE9AFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6689 24C51.4646 24 52.2276 23.6839 52.7902 23.1213C53.3528 22.5587 53.6689 21.7956 53.6689 21H56.6689C56.6689 22.5913 56.0368 24.1174 54.9115 25.2426C53.7863 26.3679 52.2602 27 50.6689 27H45.6689L45.6289 26.98C46.2261 26.052 46.7001 25.0503 47.0389 24H50.6689Z",
    fill: "#AE9AFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.668 3H56.668V9H53.668V6H47.668V3Z",
    fill: "#AE9AFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47.038 24C46.6992 25.0503 46.2252 26.052 45.628 26.98C44.4569 28.8262 42.838 30.3462 40.9218 31.3988C39.0055 32.4513 36.8542 33.0021 34.668 33H30.668C28.4817 33.0021 26.3304 32.4513 24.4142 31.3988C22.4979 30.3462 20.879 28.8262 19.708 26.98C19.1108 26.052 18.6368 25.0503 18.298 24C17.8792 22.708 17.6666 21.3581 17.668 20V1H47.668V20C47.6693 21.3581 47.4567 22.708 47.038 24Z",
    fill: "#AF9AFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.668 1V20C43.6693 21.3581 43.4567 22.708 43.038 24C42.6992 25.0503 42.2252 26.052 41.628 26.98C40.4569 28.8262 38.838 30.3462 36.9218 31.3988C35.0055 32.4513 32.8542 33.0021 30.668 33H34.668C36.8542 33.0021 39.0055 32.4513 40.9218 31.3988C42.838 30.3462 44.4569 28.8262 45.628 26.98C46.2252 26.052 46.6992 25.0503 47.038 24C47.4567 22.708 47.6693 21.3581 47.668 20V1H43.668Z",
    fill: "#BBAAFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.708 26.98C23.1108 26.052 22.6368 25.0503 22.298 24C21.8792 22.708 21.6666 21.3581 21.668 20V1H17.668V20C17.6666 21.3581 17.8792 22.708 18.298 24C18.6368 25.0503 19.1108 26.052 19.708 26.98C20.879 28.8262 22.4979 30.3462 24.4142 31.3988C26.3304 32.4513 28.4817 33.0021 30.668 33H34.668C32.4817 33.0021 30.3304 32.4513 28.4142 31.3988C26.4979 30.3462 24.879 28.8262 23.708 26.98Z",
    fill: "#937DEF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M57.668 9V21H56.668H53.668V9H56.668H57.668Z",
    fill: "#D2C7FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M39.668 39H25.668V43H39.668V39Z",
    fill: "#DCE1EB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M47.668 59V63H17.668V59H19.668H45.668H47.668Z",
    fill: "#937DEF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M44.668 43L45.668 59H19.668L20.668 43H25.668H39.668H44.668Z",
    fill: "#937DEF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M40.668 47L41.668 55H23.668L24.668 47H40.668Z",
    fill: "#BBAAFF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M28.668 50H26.668V52H28.668V50Z",
    fill: "#9196AA"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M38.668 50H30.668V52H38.668V50Z",
    fill: "#9196AA"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M19.793 57L19.668 59H45.668L45.543 57H19.793Z",
    fill: "#6D58C1"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M22.668 5C22.668 4.44772 22.2203 4 21.668 4C21.1157 4 20.668 4.44772 20.668 5C20.668 5.55228 21.1157 6 21.668 6C22.2203 6 22.668 5.55228 22.668 5Z",
    fill: "#FFECCF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M43.668 4H25.668C25.1157 4 24.668 4.44772 24.668 5C24.668 5.55228 25.1157 6 25.668 6H43.668C44.2203 6 44.668 5.55228 44.668 5C44.668 4.44772 44.2203 4 43.668 4Z",
    fill: "#FFECCF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M28.668 50H26.668V52H28.668V50Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M38.668 50H30.668V52H38.668V50Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M22.668 4H20.668V6H22.668V4Z",
    fill: "#4329AD"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M44.668 4H24.668V6H44.668V4Z",
    fill: "#4329AD"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopVolume);
export default __webpack_public_path__ + "static/media/topVolume.9a3468bfa18e40af52fe548f6d1b9c31.svg";
export { ForwardRef as ReactComponent };